import { useContext } from "react";
import {
  ConnectBackboneToReactContext,
  IBackboneContext,
} from "./ModelProvider";

const useBackboneContext = () =>
  useContext<IBackboneContext>(ConnectBackboneToReactContext);
export default useBackboneContext;
